module.exports = __webpack_public_path__ + "img/chatroom.7cf494ca.jpg";